import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { images } from "../assets/images";
import { BackgroundMedia } from "./BackgroundMedia";

export function SchoolSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      ref={ref}
      className="relative h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <BackgroundMedia
          videoSrc={images.school}
          imageSrc={images.schoolImage}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/20" />
      </div>

      {/* Content - 手写体呈现孩子视角 */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={isInView ? { opacity: 1, scale: 1, y: 0 } : { opacity: 0, scale: 0.9, y: 20 }}
        transition={{ duration: 1.5, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 text-center px-6"
      >
        <motion.p
          animate={isInView ? {
            y: [0, -8, 0],
          } : {}}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 1.5
          }}
          className="text-white text-xl md:text-3xl lg:text-4xl italic"
          style={{ 
            fontFamily: "'Caveat', cursive",
            textShadow: "0 4px 20px rgba(0,0,0,0.5)",
            letterSpacing: "0.02em"
          }}
        >
          我们的学校 成了废墟
        </motion.p>
      </motion.div>
    </section>
  );
}

